import type { InjectionKey } from 'vue'

export const reloadTicketsKey = Symbol('reloadTickets') as InjectionKey<() => void>
